<template>
  <button
    v-bind="$attrs"
    :disabled="disabled"
    class="button"
    @click="$emit('setAction')"
    :class="[btnColor, { disabled }]"
  >
    <div class="button__container" :class="{'no-padding': noPadding}">
      {{ label }}
      <slot class="icon"></slot>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    btnColor: {
      type: String,
      default: 'dark'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/base_button.scss';
</style>



// WEBPACK FOOTER //
// src/components/base/BaseButton.vue